<script>
import StringUtils from '@/utils/stringUtils'

export default
{
    name: 'checkbox',

    props:
    {
        icon: { type: String },
        label: { type: String },
        // bound to v-show
        show: { type: Boolean, default: true },

        // bound to v-model.
        value: { type: Boolean }
    },

    created ()
    {
        this.isChecked = this.value
    },

    render () 
    {
        return (
            <div class='checkbox' ref='checkbox' on-click={this.onClick} v-show={this.show}>
                { this.icon && <inline-svg class='left-icon' src={this.icon} /> }
                <p class='label' v-show={this.hasLabel}>{ this.label }</p>
                <div class={`check-icon ${!this.hasLabel ? 'centered' : ''}`}>
                    <inline-svg src={require('@/assets/img/checked.svg')} />
                </div>
            </div>
        )
    },

    data () 
    {
        return {
            isChecked: false
        }
    },

    watch:
    {
        value ()
        {
                this.isChecked = this.value
        },

        isChecked ()
        {
            if (this.isChecked)
            {
                this.$refs.checkbox.classList.add('checked')
            }
            else this.$refs.checkbox.classList.remove('checked')

            this.$emit('input', this.isChecked)
        }
    },

    computed:
    {
        hasLabel ()
        {
            return !StringUtils.isEmptyString(this.label)
        }
    },

    mounted ()
    {
    },

    methods:
    {
        onClick ()
        {
            this.isChecked = !this.isChecked
            this.$emit('click', this.isChecked)
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.checkbox
{
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 5px;
    padding: 15px;
    transition: all 0.2s ease-out;
    background-color: var(--theme-border-color-mega-light);
    fill: var(--theme-border-color-extra-strong);
    box-shadow: var(--theme-box-shadow-soft);
    font-size: 13px;
    cursor: pointer;

    &.checked
    {
        background-color: var(--theme-accent-color-light);
        box-shadow: var(--theme-box-shadow-sharp);

        .left-icon
        {
            fill: var(--theme-accent-color-light-100-percent);
        }

        .label
        {
            color: white;
        }

        .check-icon
        {
            border-color: transparent;

            svg
            {
                fill: var(--theme-accent-color-light-30-percent);
                opacity: 1;
            }
        }
    }

    .left-icon
    {
        .WidthHeight(15px);
        margin-right: 10px;
        fill: inherit;
    }

    .label
    {
        font-size: inherit;
    }

    .check-icon
    {
        border: solid 2px var(--theme-border-color);
        border-radius: 50%;
        width: 15px;
        height: 15px;
        margin-left: auto;

        .OnTabletOnly({ .WidthHeight(20px); });

        &.centered
        {
            margin-left: auto;
            margin-right: auto;
        }

        svg
        {
            opacity: 0;
            width: inherit;
            height: inherit;

            .OnTablet({
                margin-bottom: 100%;
            });
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Checkbox.vue